import { TColor } from '../../types/TStyleVariables';

// Map older color variants to use token colors
const _colorMap = {
  success: 'text-on-background-success-soft',
  error: 'text-on-background-error-soft',
  action: 'text-link-default',
  inverse: 'text-inverse',
  secondary: 'text-secondary',
  info: 'text-on-background-info-soft',
  warning: 'text-on-background-warning-soft',
  link: 'text-link-default',

  // FIXME: added to support in-page Icon default icon color is text-primary
  neutral: 'text-primary',
  helper: 'text-primary',
} as const;

export const colorMap: Record<keyof typeof _colorMap, TColor> = _colorMap;
export type TIconColor = TColor | keyof typeof colorMap;
